module.exports = __webpack_public_path__ + "static/media/Acrilico (1).25b9fef3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (1).jpg
// module id = 288
// module chunks = 0